import { createSlice } from '@reduxjs/toolkit';

const placesSlice = createSlice({
  name: 'place',
  initialState: {
    getPlacesData: [],
    getPlacesDataIsLoading: false,
    getPlacesDataErrorMsg: null,
  },
  reducers: {
    getPlacesReq: (state, action) => { },
    getPlacesSuccess: (state, action) => ({
      ...state,
      getPlacesData: action.payload,
      getPlacesDataIsLoading: false,
      getPlacesDataErrorMsg: null,
    }),
    getPlacesFailure: (state, action) => ({
      ...state,
      getPlacesDataIsLoading: false,
      getPlacesDataErrorMsg: action.payload,
    }),
    getPlacesLoading: (state) => ({
      ...state,
      getPlacesDataIsLoading: true,
      getPlacesDataErrorMsg: null,
    }),
    getPlacesClear: (state) => ({
      ...state,
      getPlacesData: [],
      getPlacesDataIsLoading: false,
      getPlacesDataErrorMsg: null,
    }),
  },
});

export const {
  getPlacesClear,
  getPlacesFailure,
  getPlacesLoading,
  getPlacesReq,
  getPlacesSuccess,
} = placesSlice.actions;

export default placesSlice.reducer;
